import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "checkmark-a",
		d: "M2.354 5.854h8.5a.5.5 0 1 1 0 1h-9a.498.498 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v3.5z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "checkmark-b",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#checkmark-a",
					style: { display: "none" }
				})
			}),
			/* @__PURE__ */ _jsx("use", {
				fill: "currentColor",
				transform: "rotate(-45 6.354 4.354)",
				xlinkHref: "#checkmark-a"
			}),
			/* @__PURE__ */ _jsx("path", {
				display: "none",
				fill: "#4A4A4A",
				d: "M0 0h12v12H0z",
				mask: "url(#checkmark-b)"
			})
		]
	})]
});
export default SvgCheckMark;
